import { render, staticRenderFns } from "./product-brands-winners.modal.vue?vue&type=template&id=5bff67d2&scoped=true&"
import script from "./product-brands-winners.modal.vue?vue&type=script&lang=js&"
export * from "./product-brands-winners.modal.vue?vue&type=script&lang=js&"
import style0 from "./product-brands-winners.modal.vue?vue&type=style&index=0&id=5bff67d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff67d2",
  null
  
)

export default component.exports